/** Join class names (BEM helpers for CSS components). */
export const cx = (...classes) => classes.filter(Boolean).join(" ");
